@reference "@glow/tailwind-config/reference.css";

.wrap table {
  @apply w-full;
  @apply relative;
  border-collapse: collapse;
}

.wrap thead tr {
  @apply h-12;
  @apply drop-shadow-01;
  @apply bg-gray-100;
}

.wrap tbody tr {
  @apply mb-2;
  @apply h-16;
}

.wrap tbody tr:hover {
  @apply bg-neutral-100;
}

.wrap th,
.wrap td {
  @apply align-middle;
}
.wrap th:first-child,
.wrap td:first-child div {
  @apply rounded-l-lg;
}
.wrap th:last-child,
.wrap td:last-child div {
  @apply rounded-r-lg;
}

.wrap th {
  @apply text-left;
  @apply whitespace-nowrap;
  @apply overflow-hidden;
  @apply bg-gray-200;
  @apply text-emphasis-medium;
  @apply text-xs;
  @apply align-middle;
}
.wrap td {
  @apply p-0;
  @apply pt-2;
  @apply text-emphasis-high;
}

.wrap tr:last-child td {
  @apply pb-0;
}

.wrap td:first-child:before {
  box-sizing: border-box;
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  display: block;
  @apply drop-shadow-01;
  @apply bg-white;
  @apply rounded-lg;
  @apply h-16;
  @apply -z-10;
}
